import Cookies from 'js-cookie';
import { saveBookmark, getBookmarkList, delBookmarkList } from '../../api/index';
export default {
  name: 'bookMarkManage',
  components: {},
  data() {
    return {
      addBookModal: false,
      uploadHeader: { accessToken: Cookies.get('accessToken') },
      data: [],
      total: 0,
      searchForm: {
        pageNumber: 1, // 当前页数
        pageSize: 4, // 页面大小
        sort: 'createTime', // 默认排序字段
        order: 'desc', // 默认排序方式
      },
      isActive: true,
      position: '',
      addForm: {
        title: '',
      },
      delId: '',
      bookspinShow: false,
      add_loading: false,
      xbootConfig: '',
    };
  },
  props: {},
  watch: {},
  computed: {},
  //监测渲染变化，从而获取全屏状态值
  mounted() {},
  created() {
    this.xbootConfig = this.publicMethod.xbootConfig;
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.bookspinShow = true;
      getBookmarkList(this.searchForm).then(res => {
        this.bookspinShow = false;
        console.log('书签列表', res);
        if (res.success) {
          this.data = res.result.content;
          this.total = res.result.totalElements;
        }
      });
    },
    addBookMark() {
      this.addBookModal = true;
      this.addForm.title = '';
    },

    saveAs() {
      if (!this.addForm.title) {
        this.$Message.info('请填写书签名称！');
        return;
      }
      this.add_loading = true;
      var view = this.olmap.getView().calculateExtent(this.olmap.getSize());
      var that = this;
      this.olmap.once('postcompose', function(event) {
        var canvas = event.context.canvas;
        if (!navigator.msSaveBlob) {
          canvas.toBlob(function(blob) {
            let files = new window.File([blob], 'map.png', { type: blob.type });
            let formData = new FormData();
            formData.append('file', files);
            formData.append('title', that.addForm.title);
            formData.append('extent', view);
            saveBookmark(formData).then(res => {
              console.log('参数', formData);
              console.log('结果', res);
              that.add_loading = false;
              if (res.success) {
                that.$Message.success('保存成功');
                that.addBookModal = false;
                that.getDataList();
              } else {
                that.$Message.info(res.message);
              }
            });
          });
        }
      });
      this.olmap.renderSync();
    },

    delBookmark() {
      if (!this.delId) return this.$Message.info('请选择一个书签');
      this.$Modal.confirm({
        title: '确认删除',
        // 记得确认修改此处
        content: '您确认要删除该条书签？',
        onOk: () => {
          // 删除
          delBookmarkList(this.delId).then(res => {
            if (res.success === true) {
              this.position = '';
              this.delId = '';
              this.$Message.success('操作成功');
              this.getDataList();
            }
          });
        },
      });
    },
    //定位
    setPostion(item, index) {
      var extentList = [];
      if (item.extent.indexOf(',') != -1) {
        var arr = item.extent.split(',');
        arr.forEach((itemCode, index) => {
          itemCode = Number(itemCode);
          extentList.push(Number(itemCode));
        });
      }
      this.position = index;
      this.olmap.getView().fit(extentList);
      this.delId = item.id;
      console.log('id', item.id);
      console.log('定位', this.delId);
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/bookMarkManage/bookMarkManage.js